import { render, staticRenderFns } from "./BaseListGroup.vue?vue&type=template&id=f445e4b6&"
import script from "./BaseListGroup.vue?vue&type=script&lang=ts&"
export * from "./BaseListGroup.vue?vue&type=script&lang=ts&"
import style0 from "./BaseListGroup.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VDivider,VListItemContent,VListItemTitle,VSubheader})
